// extracted by mini-css-extract-plugin
module.exports = {"image":"ViewPdfButton_image__1e4Dg","inline":"ViewPdfButton_inline__jOS8p","text":"ViewPdfButton_text__c_82K","container":"ViewPdfButton_container__2ePr2"};